/**
 * BillingDocument - 청구서/영수증/견적서 문서
 * 일본 비즈니스 문서 형식 (적격청구서 등) 지원
 * 
 * Firestore Path: workspaces/{id}/billing_documents/{docId}
 */

import { BillingCountry, BillingProfile } from './BillingProfile';

export type BillingDocumentType = 'INVOICE' | 'RECEIPT' | 'ESTIMATE';
export type BillingDocumentStatus = 'draft' | 'issued' | 'paid' | 'canceled';

export interface BillingDocumentItem {
    description: string;       // 품목 설명 (e.g., 'NextPOD Premium 1年間サブスクリプション')
    quantity: number;
    unitPrice: number;
    amount: number;            // quantity * unitPrice
}

export interface IssuerInfo {
    name: string;              // 발행자 회사명 (e.g., 'Sunbi Soft')
    registrationNumber: string; // 적격청구서 등록번호
    address: string;
    phone?: string;
    email?: string;
    bankInfo?: string;         // 입금 계좌 정보
}

export interface BillingDocument {
    id: string;                // e.g., 'INV-202601-001'
    type: BillingDocumentType;
    country: BillingCountry;

    workspaceId: string;

    // Financial
    subtotal: number;          // 세전 합계
    taxRate: number;           // e.g., 0.1 (10%)
    taxAmount: number;         // 소비세액
    total: number;             // 세후 합계
    currency: 'JPY' | 'KRW' | 'USD';

    // Parties
    issuer: IssuerInfo;
    recipient: Partial<BillingProfile>; // 스냅샷

    // Items
    items: BillingDocumentItem[];

    // Dates
    issueDate: Date;           // 발행일
    dueDate?: Date;            // 지불 기한 (청구서)
    paidDate?: Date;           // 입금 확인일 (영수증)

    // Meta
    status: BillingDocumentStatus;
    notes?: string;            // 비고
    createdBy: string;         // Admin UID
    createdAt: Date;
    updatedAt?: Date;
}

// 기본 발행자 정보 (설정에서 관리 가능하도록 추후 확장)
export const DEFAULT_ISSUER_JP: IssuerInfo = {
    name: 'Sunbi Soft',
    registrationNumber: 'T0000000000000', // TODO: 실제 등록번호로 교체
    address: '〒000-0000 東京都...',       // TODO: 실제 주소로 교체
    email: 'billing@sunbisoft.com',
};

export const generateDocumentId = (type: BillingDocumentType, date: Date): string => {
    const prefix = type === 'INVOICE' ? 'INV' : type === 'RECEIPT' ? 'RCP' : 'EST';
    const yearMonth = `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}`;
    const random = String(Math.floor(Math.random() * 1000)).padStart(3, '0');
    return `${prefix}-${yearMonth}-${random}`;
};
